import { render, staticRenderFns } from "./IconCheckCircle.vue?vue&type=template&id=20faea22&scoped=true&"
import script from "./IconCheckCircle.vue?vue&type=script&lang=js&"
export * from "./IconCheckCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20faea22",
  null
  
)

export default component.exports